import React from "react";
import { Formik, Form, ErrorMessage } from "formik";
import {
  Spinner,
  Form as BForm,
  InputGroup,
  Button,
} from "@themesberg/react-bootstrap";

import { verificationCodeSchema } from "./staffSchema";

const VerificationForm = ({ onSubmit, onBack, loading = false }) => {
  return (
    <div className="bg-white p-2 p-lg-5 w-100">
      <div className="text-center text-md-center mb-4 mt-md-0">
        <h2 className="mb-2 login-heading">Verification Required</h2>
        <p className="text-muted">
          Please enter the verification code sent to your registered email.
        </p>
      </div>

      <Formik
        initialValues={{ verificationCode: "" }}
        validationSchema={verificationCodeSchema}
        onSubmit={({ verificationCode }) => onSubmit({ verificationCode })}
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleSubmit,
          handleBlur,
        }) => (
          <div>
            <Form>
              <div className="form-group">
                <label
                  htmlFor="verificationCode"
                  className={`${touched.verificationCode && errors.verificationCode
                    ? "text-danger"
                    : ""
                    }`}
                >
                  Verification Code
                  <small className="text-muted ms-2">(4-8 characters)</small>
                </label>

                <InputGroup
                  className={
                    touched.verificationCode && errors.verificationCode
                      ? "border border-danger"
                      : ""
                  }
                >
                  <BForm.Control
                    name="verificationCode"
                    autoFocus
                    required
                    type="text"
                    placeholder="******"
                    value={values.verificationCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    maxLength={8}
                    className="text-center"
                    style={{
                      letterSpacing: "3px",
                      fontFamily: "monospace",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  />
                </InputGroup>

                <ErrorMessage
                  component="div"
                  name="verificationCode"
                  className="text-danger"
                />
              </div>

              <div className="d-flex gap-2 mt-4">
                <Button
                  variant="outline-secondary"
                  type="button"
                  onClick={onBack}
                  disabled={loading}
                  className="flex-fill"
                >
                  Back to Login
                </Button>

                <button
                  type="submit"
                  className="btn btn-primary flex-fill"
                  onClick={handleSubmit}
                  disabled={loading || !values.verificationCode || errors.verificationCode}
                >
                  {loading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                  )}
                  Verify & Sign In
                </button>
              </div>
            </Form>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default VerificationForm;
